<template>
  <div class="bg-main-color mt-32 dark:bg-gray-900">
    <div class="container mx-auto lg:px-24 py-24 space-y-12">
      <div class="flex justify-center">
        <div class="w-2/3 space-y-6">
          <div class="text-center text-2xl font-semibold">SchoolBoard Free gift</div>
          <div class="text-center ">SchoolBoard adalah aplikasi Realtime yang ditujukan untuk membantu dan mempermudah kegiatan belajar mengajar di sekolah!</div>
        </div>
      </div>
      <div class="flex flex-wrap justify-center grid lg:grid-cols-3 gap-3">
        <div class="bg-gray-800 p-5 rounded-lg mx-4 my-4  space-y-6">
          <div class="h-12 w-12 rounded-full bg-white">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="fill-current text-cyan-600 h-12 w-12">
              <path d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
            </svg>
          </div>
          <div>
            <h1 class="text-lg text-white font-semibold">#RealtimeToDoList</h1>
            <p class="text-white">Memberikan tugas atau pengumuman menjadi lebih mudah tanpa harus menggunakan chat app.</p>
          </div>
          <div class="text-cyan-600 font-semibold">free package</div>
        </div>
        <div class="bg-gray-800 p-5  rounded-lg  mx-4 my-4  space-y-6 ">
          <div class="h-12 w-12 rounded-full bg-white">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="fill-current text-cyan-600 h-12 w-12">
              <path d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
            </svg>
          </div>
          <div>
            <h1 class="text-lg text-white font-semibold">#Realtime Blog</h1>
            <p class="text-white">Posting artikel atau materi pelajaran untuk siswa secara realtime untuk mempermudah siswa belajar.</p>
          </div>
          <div class="text-cyan-600 font-semibold">free package</div>
        </div>
        <div class="bg-gray-800 p-5  rounded-lg  mx-4 my-4  space-y-6 ">
          <div class="h-12 w-12 rounded-full bg-white">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="fill-current text-cyan-600 h-12 w-12">
              <path d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
            </svg>
          </div>
          <div>
            <h1 class="text-lg text-white font-semibold">#RealtimeCollab Room</h1>
            <p class="text-white">Belajar tidak harus selalu di ruang kelas kapanpun dan dimanapun kegiatan belajar mengajar bisa dilakukan.</p>
          </div>
          <div class="text-cyan-600 font-semibold">Coming Soon</div>
        </div>
        <div class="bg-gray-800 p-5  rounded-lg  mx-4 my-4  space-y-6 ">
          <div class="h-12 w-12 rounded-full bg-white">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="fill-current text-cyan-600 h-12 w-12">
              <path d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
            </svg>
          </div>
          <div>
            <h1 class="text-lg text-white font-semibold">#Quiz Room</h1>
            <p class="text-white">Buat soal ulangan untuk siswa dan dapatkan hasilnya tanpa harus koreksi secara manual.</p>
          </div>
          <div class="text-cyan-600 font-semibold">Coming Soon</div>
        </div>
        <div class="bg-gray-800 p-5  rounded-lg  mx-4 my-4  space-y-6 ">
          <div class="h-12 w-12 rounded-full bg-white">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="fill-current text-cyan-600 h-12 w-12">
              <path d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
            </svg>
          </div>
          <div>
            <h1 class="text-lg text-white font-semibold">#English Lab</h1>
            <p class="text-white">Vocabulary flashcard dengan audio games dan Quiz untuk mempercepat siswa dalam belajar bahasa Inggris.</p>
          </div>
          <div class="text-cyan-600 font-semibold">Coming Soon</div>
        </div>
        <div class="bg-gray-800 p-5  rounded-lg  mx-4 my-4  space-y-6 ">
          <div class="h-12 w-12 rounded-full bg-white">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="fill-current text-cyan-600 h-12 w-12">
              <path d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
            </svg>
          </div>
          <div>
            <h1 class="text-lg text-white font-semibold">#Note</h1>
            <p class="text-white">Membuat Catatan tidak harus repot menggunakan buku tulis dan membawa nya kemana mana.</p>
          </div>
          <div class="text-cyan-600 font-semibold">Coming Soon</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
